import { $, localizations } from '../Common/globals.js';

var unauthorizedState = false;

$.ajaxSetup({
  xhrFields: {
    withCredentials: true // This setting passes cookies along the request, including our authentication cookie.
  }
});

$(document).ajaxError(function (event, jqxhr, settings, thrownError) {
  if (jqxhr.status == "401" && !unauthorizedState) {
    unauthorizedState = true;

    if ($("body").data("active") != "true") {
      $("body").data("active", "true");

      $(".overlay__container").hide();

      let modal = `<div style="position:absolute;width:100vw;height:100vh;top:0;background-color:rgba(0,0,0,0.2);z-index:9950;display:flex;align-items:center;justify-content:space-around;"><div style="height:200px; width:300px;padding:20px;background-color:white;z-index:9960;display:flex;flex-direction:column;justify-content:space-around;"><p>${localizations.dbRes("DitLoginErUdløbet")}</p><button id="relogin" class="button">OK</button></div></div>`;

      $("body").append(modal);

      $("#relogin").on("click", () => {
        window.location.href = "/Identity/Account/Login?returnUrl=" + window.location.pathname + window.location.search;
      });
    }
  }
});

var call = function (url, settings) {
  if (typeof url === "string" || url instanceof String) {
    if (url !== "") {
      settings.url = url;
    }
  } else {
    settings = url; //single argument jQuery.ajax
  }

  return $.ajax(settings);
};

export const Call = call;